var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7233 17.1075C18.1848 17.1075 20.9909 14.3014 20.9909 10.8399C20.9909 7.37837 18.1848 4.57227 14.7233 4.57227C11.2618 4.57227 8.45572 7.37837 8.45572 10.8399C8.45572 14.3014 11.2618 17.1075 14.7233 17.1075Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16956 25.9476C6.02176 25.0966 6.0828 24.2148 6.0828 23.3553C6.0828 20.1161 8.70868 17.4902 11.9479 17.4902H17.6589C18.0943 17.4902 18.5185 17.5377 18.9268 17.6276",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6509 19.4105L24.7089 21.5386C24.7613 21.6458 24.8645 21.7209 24.9825 21.737L27.3507 22.0804C27.4473 22.0924 27.5331 22.1434 27.5921 22.2198C27.702 22.3633 27.686 22.5672 27.5532 22.6905L25.8368 24.3506C25.7496 24.4325 25.7107 24.5532 25.7335 24.6698L26.1452 27.0125C26.1733 27.2069 26.0405 27.388 25.8475 27.4201C25.7671 27.4322 25.6839 27.4201 25.6115 27.384L23.5021 26.279C23.3961 26.2213 23.2688 26.2213 23.1628 26.279L21.0387 27.3893C20.8604 27.4805 20.6431 27.4134 20.5465 27.2392C20.5104 27.1694 20.4969 27.0889 20.5089 27.0098L20.9207 24.6685C20.9408 24.5518 20.9019 24.4325 20.8175 24.3493L19.0916 22.6892C18.9521 22.5497 18.9521 22.3217 19.0916 22.1822C19.1492 22.13 19.2216 22.0937 19.2981 22.0804L21.6676 21.7357C21.7856 21.7182 21.8876 21.6432 21.9412 21.536L22.9979 19.4105C23.0408 19.3246 23.1159 19.2576 23.2071 19.2281C23.2983 19.1972 23.3988 19.204 23.486 19.2469C23.5571 19.283 23.6147 19.3393 23.6509 19.4105Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStar);
export default __webpack_public_path__ + "static/media/User-star.635c8909.svg";
export { ForwardRef as ReactComponent };